const NAMESPACE = 'jbp-manager-dashboard'

export const COVERAGE_TRANSLATION_KEYS = {
  title: `${NAMESPACE}--coverage-report-title`,
  marketFilterTitle: `${NAMESPACE}--coverage-report-market-filter-title`,
  noData: `${NAMESPACE}--coverage-report-no-data`,
  exportPartnersCoverage: `${NAMESPACE}--export-partners-coverage`,
}
